var Config = {
    DEBUG: false,
    LIB_VERSION: '2.67.0'
};

export default Config;
